// import React, { useState, useEffect, useRef } from 'react';
// import { useParams, useLocation, useNavigate } from 'react-router-dom';
// import html2canvas from 'html2canvas';
// import axios from 'axios';
// import { Button,Spinner } from '@material-tailwind/react';
// import defaultBackground from '../../assets/Record/recordprint.jpg';

// interface LayoutText {
//   custom_id: string;
//   text: string;
//   x: number;
//   y: number;
//   font: string;
//   color: string;
// }

// interface LayoutConfig {
//   texts: LayoutText[];
//   bg_image?: string;
// }

// type RecordData = {
//   Competition: string;
//   Bib: string;
//   Name: string;
//   Division: string;
//   Time: string;
// };

// const RecordMobilePrint = () => {
//   const { compTitle, bibNum } = useParams<{ compTitle?: string; bibNum?: string }>();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const stateData = (location.state as {
//     userName?: string;
//     compTitle?: string;
//     compDivLs?: string;
//     compRecord?: string;
//     compBib?: string;
//     compCode?: number;
//     sex?: string;
//   }) || {};

//   // 참가자 및 대회 정보
//   const [userName, setUserName] = useState(stateData.userName || '이름 없음');
//   const [userBib, setUserBib] = useState(stateData.compBib || (bibNum || '-'));
//   const [compTitleState, setCompTitleState] = useState(stateData.compTitle || '마라톤 대회');
//   const [compDivLs, setCompDivLs] = useState(stateData.compDivLs || 'Full');
//   const [compRecord, setCompRecord] = useState(stateData.compRecord || '기록이 없습니다.');
//   const [compCodeState, setCompCodeState] = useState<number | null>(stateData.compCode || null);
//   const rawSex = (stateData.sex ?? '').trim();
//   useEffect(() => {
//     if (stateData.compCode) {
//       setCompCodeState(stateData.compCode);
//     }
//   }, [stateData.compCode]);

//   // 레이아웃 정보 (mode=photo)
//   const [layoutConfig, setLayoutConfig] = useState<LayoutConfig | null>(null);
//   useEffect(() => {
//     if (compCodeState) {
//       axios.get(`/api/get-layout/${compCodeState}?mode=mobile`)
//         .then((res) => {
//           console.log("Fetched layout:", res.data);
//           const raw = res.data;
//           let parsedTexts: LayoutText[] = [];
//           if (raw.layout_config) {
//             try {
//               const parsedObj = JSON.parse(raw.layout_config);
//               parsedTexts = parsedObj.texts || [];
//             } catch(e) {
//               console.error("JSON parse error", e);
//             }
//           }
//           const finalData: LayoutConfig = {
//             bg_image: raw.bg_image,
//             texts: parsedTexts
//           };
//           setLayoutConfig(finalData);
//         })
//         .catch((err) => {
//           console.error("레이아웃 불러오기 오류:", err);
//         });
//     }
//   }, [compCodeState]);

//   // 사용자 업로드 이미지 상태 (증명사진)
//   const [userImageUrl, setUserImageUrl] = useState<string>('');
//   const [uploadedFile, setUploadedFile] = useState<File | null>(null);
//   const canvasRef = useRef<HTMLDivElement>(null);

//   // 배경 이미지 URL: layoutConfig에서 가져오거나 기본 이미지 사용
//   const backgroundUrl = layoutConfig && layoutConfig.bg_image
//     ? `/static/images/${layoutConfig.bg_image}`
//     : defaultBackground;

//   // A4 사이즈 캔버스 (기본값: portrait A4: 595x842)
//   const [canvasWidth, setCanvasWidth] = useState(595);
//   const [canvasHeight, setCanvasHeight] = useState(842);

//   // 배경 이미지의 자연 크기를 읽어 A4 크기 결정 (landscape vs portrait)
//   useEffect(() => {
//     const img = new Image();
//     img.src = backgroundUrl;
//     img.onload = () => {
//       if (img.naturalWidth > img.naturalHeight) {
//         setCanvasWidth(842);
//         setCanvasHeight(595);
//       } else {
//         setCanvasWidth(595);
//         setCanvasHeight(842);
//       }
//     };
//   }, [backgroundUrl]);

//   // 동적 반응형 스케일링: 화면 너비에 따라 scale 적용
//   const [scale, setScale] = useState(1);
//   useEffect(() => {
//     const handleResize = () => {
//       if (canvasWidth) {
//         const availableWidth = window.innerWidth - 20;
//         const newScale = Math.min(1, availableWidth / canvasWidth);
//         setScale(newScale);
//       }
//     };
//     window.addEventListener('resize', handleResize);
//     handleResize();
//     return () => window.removeEventListener('resize', handleResize);
//   }, [canvasWidth]);

//   // 파일 업로드 처리: 사용자 이미지 URL 저장
//   const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     if (e.target.files && e.target.files[0]) {
//       const file = e.target.files[0];
//       setUploadedFile(file);
//       const localUrl = URL.createObjectURL(file);
//       setUserImageUrl(localUrl);
//     }
//   };

//   const captureCanvas = (callback: (dataUrl: string) => void) => {
//     if (canvasRef.current) {
//       html2canvas(canvasRef.current, {
//         scale: 4,
//         useCORS: true,
//         onclone: (clonedDoc) => {
//           const overlays = clonedDoc.querySelectorAll('.overlay-text');
//           overlays.forEach(el => {
//             const computedStyle = window.getComputedStyle(el);
//             const currentTop = computedStyle.top;
//             const topVal = parseFloat(currentTop);
//             // 텍스트 위치를 위로 10px 올림
//             (el as HTMLElement).style.top = (topVal - 10) + "px";
//           });
//         }
//       }).then(canvas => {
//         const dataUrl = canvas.toDataURL("image/png");
//         callback(dataUrl);
//       });
//     }
//   };
  


//   const handleDownload = () => {
//     captureCanvas((dataUrl) => {
//       const link = document.createElement("a");
//       link.href = dataUrl;
//       link.download = "모바일기록증.png";
//       link.click();
//     });
//   };
//   const mapping: Record<string, string> = {
//     name: userName,
//     time: compRecord,
//     div: compDivLs,
//     bib: userBib,
//     sex : rawSex || '성별 없음'
//   };
//  // 캔버스 컨텐츠 렌더링: 배경, 텍스트 오버레이, 그리고 사용자 이미지 (증명사진)
//  const renderContent = () => (
//   <div style={{ position: "relative", width: `${canvasWidth}px`, height: `${canvasHeight}px`, overflow: "hidden", backgroundColor: "#fff" }}>
//     <img
//       src={backgroundUrl}
//       alt="background"
//       style={{
//         position: 'absolute',
//         width: '100%',
//         height: 'auto',
//         left: 0,
//         top: 0,
//         objectFit: 'cover'
//       }}
//     />
//     {layoutConfig?.texts.map((item, idx) => {
//       const [fontName, fontSizeStr] = item.font.split(' ');
//       const fontSize = parseInt(fontSizeStr) || 20;
//       const displayText = mapping[item.custom_id] ?? item.text ?? item.custom_id;
//       return (
//         <div
//           key={idx}
//           className="overlay-text"
//           style={{
//             position: 'absolute',
//             left: item.x,
//             top: item.y,
//             transform: 'translate(-50%, 0)',
//             textAlign: 'center',
//             display: 'inline-block',
//             fontFamily: fontName,
//             fontSize: fontSize,
//             fontWeight: "bold",
//             color: item.color,
//             whiteSpace: 'nowrap'
//           }}
//         >
//           {displayText}
//         </div>
//       );
//     })}
//   </div>
// );

// // layoutConfig가 로드되지 않은 경우 로딩 스피너를 표시
// if (layoutConfig === null) {
//   return (
//     <div className="flex justify-center items-start h-screen bg-white pt-40">
//       <h1 className="text-2xl md:text-4xl font-bold text-center text-red-600">
//         이번 대회에서는 모바일 기록증을 서비스하지 않습니다.
//       </h1>
//     </div>
//   );
// }
// // if (layoutConfig === null) {
// //   return (
// //     <div className="flex justify-center items-center h-screen">
// //       <Spinner color="blue" className="w-12 h-12" />
// //     </div>
// //   );
// // }

// return (
//   <div className="flex justify-center flex-col items-center">
//     {/* 디버그용 */}
//     <div style={{ position: 'absolute', top: 0, right: 0, color: 'red', fontSize: '16px' }}>
//       compCode: {compCodeState}
//     </div>
//     {/* 동적 스케일 적용 컨테이너 */}
//     <div className="mt-8 mb-8 mx-auto" style={{ width: canvasWidth * scale, height: canvasHeight * scale }}>
//       <div
//         id="canvas-container"
//         ref={canvasRef}
//         style={{
//           transform: `scale(${scale})`,
//           transformOrigin: 'top left',
//           width: canvasWidth,
//           height: canvasHeight,
//         }}
//       >
//         {renderContent()}
//       </div>
//     </div>
//     <div className="flex gap-4 mb-4">
//       <Button variant="filled" color="blue" onClick={handleDownload}>
//         다운로드
//       </Button>
//     </div>
//   </div>
// );
// };


// export default RecordMobilePrint;

// import React, { useState, useEffect, useRef } from 'react';
// import { useParams, useLocation } from 'react-router-dom';
// import html2canvas from 'html2canvas';
// import axios from 'axios';
// import { Button } from '@material-tailwind/react';
// import defaultBackground from '../../assets/Record/recordprint.jpg';

// interface LayoutText {
//   custom_id: string;
//   text: string;
//   x: number;
//   y: number;
//   font: string;
//   color: string;
// }

// interface LayoutConfig {
//   texts: LayoutText[];
//   bg_image?: string;
// }

// const RecordMobilePrint = () => {
//   const { bibNum } = useParams<{ compTitle?: string; bibNum?: string }>();
//   const location = useLocation();

//   const stateData = (location.state as {
//     userName?: string;
//     compTitle?: string;
//     compDivLs?: string;
//     compRecord?: string;
//     compBib?: string;
//     compCode?: number;
//     sex?: string;
//   }) || {};

//   const [userName] = useState(stateData.userName || '이름 없음');
//   const [userBib] = useState(stateData.compBib || (bibNum || '-'));
//   const [compDivLs] = useState(stateData.compDivLs || 'Full');
//   const [compRecord] = useState(stateData.compRecord || '기록이 없습니다.');
//   const [compCodeState, setCompCodeState] = useState<number | null>(stateData.compCode || null);
//   const rawSex = (stateData.sex ?? '').trim();

//   const [layoutConfig, setLayoutConfig] = useState<LayoutConfig | null>(null);
//   const canvasRef = useRef<HTMLDivElement>(null);

//   useEffect(() => {
//     if (stateData.compCode) {
//       setCompCodeState(stateData.compCode);
//     }
//   }, [stateData.compCode]);

//   useEffect(() => {
//     if (!compCodeState) return;

//     axios.get(`/api/get-layout/${compCodeState}?mode=mobile`)
//       .then((res) => {
//         const raw = res.data;
//         let parsedTexts: LayoutText[] = [];

//         if (raw.layout_config) {
//           try {
//             const parsedObj = JSON.parse(raw.layout_config);
//             parsedTexts = parsedObj.texts || [];
//           } catch (e) {
//             console.error('JSON parse error', e);
//           }
//         }

//         const finalData: LayoutConfig = {
//           bg_image: raw.bg_image,
//           texts: parsedTexts
//         };

//         setLayoutConfig(finalData);
//       })
//       .catch((err) => {
//         console.error('레이아웃 불러오기 오류:', err);
//         setLayoutConfig(null);
//       });
//   }, [compCodeState]);

//   const backgroundUrl =
//     layoutConfig && layoutConfig.bg_image
//       ? `/static/images/${layoutConfig.bg_image}`
//       : defaultBackground;

//   const [canvasWidth, setCanvasWidth] = useState(595);
//   const [canvasHeight, setCanvasHeight] = useState(842);

//   useEffect(() => {
//     const img = new Image();
//     img.src = backgroundUrl;
//     img.onload = () => {
//       if (img.naturalWidth > img.naturalHeight) {
//         setCanvasWidth(842);
//         setCanvasHeight(595);
//       } else {
//         setCanvasWidth(595);
//         setCanvasHeight(842);
//       }
//     };
//   }, [backgroundUrl]);

//   const [scale, setScale] = useState(1);

//   useEffect(() => {
//     const handleResize = () => {
//       const availableWidth = window.innerWidth - 20;
//       const newScale = Math.min(1, availableWidth / canvasWidth);
//       setScale(newScale);
//     };

//     window.addEventListener('resize', handleResize);
//     handleResize();

//     return () => window.removeEventListener('resize', handleResize);
//   }, [canvasWidth]);

//   const mapping: Record<string, string> = {
//     name: userName,
//     time: compRecord,
//     div: compDivLs,
//     bib: userBib,
//     sex: rawSex || '성별 없음'
//   };

//   const renderContent = () => (
//     <div
//       style={{
//         position: 'relative',
//         width: `${canvasWidth}px`,
//         height: `${canvasHeight}px`,
//         overflow: 'hidden',
//         backgroundColor: '#fff'
//       }}
//     >
//       <img
//         src={backgroundUrl}
//         alt="background"
//         style={{
//           position: 'absolute',
//           left: 0,
//           top: 0,
//           width: '100%',
//           height: '100%',
//           objectFit: 'fill',
//           display: 'block'
//         }}
//       />

//       {layoutConfig?.texts.map((item, idx) => {
//         const fontParts = item.font.split(' ');
//         const fontName = fontParts[0] || 'sans-serif';
//         const fontSize = parseInt(fontParts[1], 10) || 20;
//         const displayText = mapping[item.custom_id] ?? item.text ?? item.custom_id;

//         return (
//           <div
//             key={idx}
//             className="overlay-text"
//             style={{
//               position: 'absolute',
//               left: `${item.x}px`,
//               top: `${item.y}px`,
//               transform: 'translateX(-50%)',
//               textAlign: 'center',
//               display: 'inline-block',
//               fontFamily: fontName,
//               fontSize: `${fontSize}px`,
//               fontWeight: 'bold',
//               color: item.color,
//               whiteSpace: 'nowrap',
//               lineHeight: 1,
//               margin: 0,
//               padding: 0
//             }}
//           >
//             {displayText}
//           </div>
//         );
//       })}
//     </div>
//   );

//   const captureCanvas = async (callback: (dataUrl: string) => void) => {
//     if (!canvasRef.current) return;

//     const canvas = await html2canvas(canvasRef.current, {
//       scale: 4,
//       useCORS: true,
//       backgroundColor: null
//     });

//     const dataUrl = canvas.toDataURL('image/png');
//     callback(dataUrl);
//   };

//   const handleDownload = async () => {
//     await captureCanvas((dataUrl) => {
//       const link = document.createElement('a');
//       link.href = dataUrl;
//       link.download = '모바일기록증.png';
//       link.click();
//     });
//   };

//   if (layoutConfig === null) {
//     return (
//       <div className="flex justify-center items-start h-screen bg-white pt-40">
//         <h1 className="text-2xl md:text-4xl font-bold text-center text-red-600">
//           이번 대회에서는 모바일 기록증을 서비스하지 않습니다.
//         </h1>
//       </div>
//     );
//   }

//   return (
//     <div className="flex justify-center flex-col items-center">
//       <div
//         className="mt-8 mb-8 mx-auto"
//         style={{
//           width: canvasWidth * scale,
//           height: canvasHeight * scale,
//           overflow: 'hidden'
//         }}
//       >
//         <div
//           style={{
//             transform: `scale(${scale})`,
//             transformOrigin: 'top left',
//             width: canvasWidth,
//             height: canvasHeight
//           }}
//         >
//           <div
//             id="canvas-container"
//             ref={canvasRef}
//             style={{
//               width: canvasWidth,
//               height: canvasHeight
//             }}
//           >
//             {renderContent()}
//           </div>
//         </div>
//       </div>

//       <div className="flex gap-4 mb-4">
//         <Button variant="filled" color="blue" onClick={handleDownload}>
//           다운로드
//         </Button>
//       </div>
//     </div>
//   );
// };

// export default RecordMobilePrint;



// import React, { useEffect, useMemo, useRef, useState } from 'react';
// import { useParams, useLocation } from 'react-router-dom';
// import axios from 'axios';
// import { Button } from '@material-tailwind/react';
// import defaultBackground from '../../assets/Record/recordprint.jpg';

// interface LayoutText {
//   custom_id: string;
//   text: string;
//   x: number;
//   y: number;
//   font_family?: string;
//   font_size?: number;
//   font?: string; // 구버전 호환
//   color: string;
//   anchor?: 'nw' | 'n' | 'ne' | string;
// }

// interface LayoutPage {
//   base_width?: number;
//   base_height?: number;
//   preview_width?: number;
//   preview_height?: number;
//   orientation?: 'portrait' | 'landscape';
// }

// interface LayoutConfig {
//   version?: number;
//   page?: LayoutPage;
//   texts: LayoutText[];
//   bg_image?: string;
// }

// const RecordMobilePrint = () => {
//   const { bibNum } = useParams<{ compTitle?: string; bibNum?: string }>();
//   const location = useLocation();

//   const stateData = (location.state as {
//     userName?: string;
//     compTitle?: string;
//     compDivLs?: string;
//     compRecord?: string;
//     compBib?: string;
//     compCode?: number;
//     sex?: string;
//   }) || {};

//   const [userName] = useState(stateData.userName || '이름 없음');
//   const [userBib] = useState(stateData.compBib || (bibNum || '-'));
//   const [compDivLs] = useState(stateData.compDivLs || 'Full');
//   const [compRecord] = useState(stateData.compRecord || '기록이 없습니다.');
//   const [compCodeState, setCompCodeState] = useState<number | null>(stateData.compCode || null);
//   const rawSex = (stateData.sex ?? '').trim();

//   const [layoutConfig, setLayoutConfig] = useState<LayoutConfig | null>(null);
//   const [isReady, setIsReady] = useState(false);

//   const canvasRef = useRef<HTMLCanvasElement>(null);

//   useEffect(() => {
//     if (stateData.compCode) {
//       setCompCodeState(stateData.compCode);
//     }
//   }, [stateData.compCode]);

//   useEffect(() => {
//     if (!compCodeState) return;

//     axios.get(`/api/get-layout/${compCodeState}?mode=mobile`)
//       .then((res) => {
//         const raw = res.data;
//         let parsedObj: LayoutConfig = { texts: [] };

//         if (raw.layout_config) {
//           try {
//             parsedObj = JSON.parse(raw.layout_config);
//           } catch (e) {
//             console.error('JSON parse error', e);
//           }
//         }

//         const finalData: LayoutConfig = {
//           ...parsedObj,
//           bg_image: raw.bg_image,
//           texts: parsedObj.texts || [],
//         };

//         setLayoutConfig(finalData);
//       })
//       .catch((err) => {
//         console.error('레이아웃 불러오기 오류:', err);
//         setLayoutConfig(null);
//       });
//   }, [compCodeState]);

//   const orientation = layoutConfig?.page?.orientation ?? 'portrait';

//   const canvasWidth =
//     layoutConfig?.page?.base_width ??
//     (orientation === 'landscape' ? 842 : 595);

//   const canvasHeight =
//     layoutConfig?.page?.base_height ??
//     (orientation === 'landscape' ? 595 : 842);

//   const backgroundUrl = useMemo(() => {
//     return layoutConfig?.bg_image
//       ? `/static/images/${layoutConfig.bg_image}`
//       : defaultBackground;
//   }, [layoutConfig?.bg_image]);

//   const [displayScale, setDisplayScale] = useState(1);

//   useEffect(() => {
//     const handleResize = () => {
//       const availableWidth = window.innerWidth - 20;
//       const nextScale = Math.min(1, availableWidth / canvasWidth);
//       setDisplayScale(nextScale);
//     };

//     window.addEventListener('resize', handleResize);
//     handleResize();

//     return () => window.removeEventListener('resize', handleResize);
//   }, [canvasWidth]);

//   const mapping: Record<string, string> = {
//     name: userName,
//     time: compRecord,
//     div: compDivLs,
//     bib: userBib,
//     sex: rawSex || '성별 없음',
//   };

//   const parseFont = (item: LayoutText): { family: string; size: number } => {
//     if (item.font_family && item.font_size) {
//       return {
//         family: item.font_family,
//         size: item.font_size,
//       };
//     }

//     const rawFont = item.font || 'Arial 20';
//     const parts = rawFont.trim().split(/\s+/);

//     if (parts.length === 1) {
//       return { family: parts[0], size: 20 };
//     }

//     const last = parts[parts.length - 1];
//     const parsedSize = parseInt(last.replace('px', ''), 10);

//     if (Number.isFinite(parsedSize)) {
//       return {
//         family: parts.slice(0, -1).join(' ') || 'Arial',
//         size: parsedSize,
//       };
//     }

//     return { family: rawFont, size: 20 };
//   };

//   const getCanvasAnchorStyle = (
//     anchor?: string
//   ): { textAlign: CanvasTextAlign; textBaseline: CanvasTextBaseline } => {
//     switch (anchor) {
//       case 'nw':
//         return { textAlign: 'left', textBaseline: 'top' };
//       case 'ne':
//         return { textAlign: 'right', textBaseline: 'top' };
//       case 'n':
//       default:
//         return { textAlign: 'center', textBaseline: 'top' };
//     }
//   };

//   const loadImage = (src: string): Promise<HTMLImageElement> => {
//     return new Promise((resolve, reject) => {
//       const img = new Image();
//       img.crossOrigin = 'anonymous';
//       img.onload = () => resolve(img);
//       img.onerror = reject;
//       img.src = src;
//     });
//   };

//   const drawCertificate = async () => {
//     if (!layoutConfig || !canvasRef.current) return;

//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext('2d');
//     if (!ctx) return;

//     canvas.width = canvasWidth;
//     canvas.height = canvasHeight;

//     ctx.clearRect(0, 0, canvasWidth, canvasHeight);

//     try {
//       if ((document as any).fonts?.ready) {
//         await (document as any).fonts.ready;
//       }

//       const bgImg = await loadImage(backgroundUrl);
//       ctx.drawImage(bgImg, 0, 0, canvasWidth, canvasHeight);

//       for (const item of layoutConfig.texts) {
//         const { family, size } = parseFont(item);
//         const text = mapping[item.custom_id] ?? item.text ?? item.custom_id;
//         const { textAlign, textBaseline } = getCanvasAnchorStyle(item.anchor);

//         ctx.font = `${size}px ${family}`;
//         ctx.fillStyle = item.color || '#000000';
//         ctx.textAlign = textAlign;
//         ctx.textBaseline = textBaseline;

//         ctx.fillText(text, item.x, item.y);
//       }

//       setIsReady(true);
//     } catch (error) {
//       console.error('Canvas draw error:', error);
//       setIsReady(false);
//     }
//   };

//   useEffect(() => {
//     setIsReady(false);
//     if (layoutConfig) {
//       drawCertificate();
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [layoutConfig, backgroundUrl, userName, userBib, compDivLs, compRecord, rawSex]);

//   const handleDownload = async () => {
//     if (!canvasRef.current) return;

//     await drawCertificate();

//     const dataUrl = canvasRef.current.toDataURL('image/png');
//     const link = document.createElement('a');
//     link.href = dataUrl;
//     link.download = '모바일기록증.png';
//     link.click();
//   };

//   if (layoutConfig === null) {
//     return (
//       <div className="flex justify-center items-start h-screen bg-white pt-40">
//         <h1 className="text-2xl md:text-4xl font-bold text-center text-red-600">
//           이번 대회에서는 모바일 기록증을 서비스하지 않습니다.
//         </h1>
//       </div>
//     );
//   }

//   return (
//     <div className="flex justify-center flex-col items-center">
//       <div
//         className="mt-8 mb-8 mx-auto bg-white"
//         style={{
//           width: canvasWidth * displayScale,
//           height: canvasHeight * displayScale,
//           overflow: 'hidden',
//         }}
//       >
//         <canvas
//           ref={canvasRef}
//           style={{
//             width: `${canvasWidth * displayScale}px`,
//             height: `${canvasHeight * displayScale}px`,
//             display: 'block',
//             backgroundColor: '#fff',
//           }}
//         />
//       </div>

//       <div className="flex gap-4 mb-4">
//         <Button variant="filled" color="blue" onClick={handleDownload} disabled={!isReady}>
//           다운로드
//         </Button>
//       </div>
//     </div>
//   );
// };

// export default RecordMobilePrint;

import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useLocation, useParams } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@material-tailwind/react';
import defaultBackground from '../../assets/Record/recordprint.jpg';

const RENDERER_VERSION = 'record-mobile-print-anchor-v4';

type LayoutAnchor =
  | 'nw'
  | 'n'
  | 'ne'
  | 'w'
  | 'center'
  | 'e'
  | 'sw'
  | 's'
  | 'se';

type LayoutField = 'name' | 'bib' | 'div' | 'time' | 'sex';
type LoadStatus = 'loading' | 'ready' | 'unavailable' | 'error';

interface LayoutText {
  custom_id: string;
  text?: string;
  x: number;
  y: number;
  font_family?: string;
  font_size?: number;
  font?: string; // 구버전 호환
  color?: string;
  anchor?: LayoutAnchor | string;
  visible?: boolean;
}

interface LayoutPage {
  base_width?: number;
  base_height?: number;
  preview_width?: number;
  preview_height?: number;
  orientation?: 'portrait' | 'landscape';
}

interface LayoutConfig {
  version?: number;
  page?: LayoutPage;
  texts: LayoutText[];
  bg_image?: string;
}

interface LayoutApiResponse {
  layout_config?: string | LayoutConfig | null;
  bg_image?: string | null;
}

interface LocationState {
  userName?: string;
  compTitle?: string;
  compDivLs?: string;
  compRecord?: string;
  compBib?: string;
  compCode?: number;
  sex?: string;
}

interface AnchorDrawResult {
  anchor: LayoutAnchor;
  textAlign: CanvasTextAlign;
  textBaseline: CanvasTextBaseline;
  bounds: {
    left: number;
    top: number;
    right: number;
    bottom: number;
  };
}

const FIELD_ALIASES: Record<string, LayoutField> = {
  name: 'name',
  이름: 'name',
  성명: 'name',
  bib: 'bib',
  number: 'bib',
  배번호: 'bib',
  배번: 'bib',
  division: 'div',
  div: 'div',
  course: 'div',
  종목: 'div',
  코스: 'div',
  time: 'time',
  record: 'time',
  기록: 'time',
  시간: 'time',
  sex: 'sex',
  gender: 'sex',
  성별: 'sex',
};

const ANCHOR_ALIASES: Record<string, LayoutAnchor> = {
  nw: 'nw',
  n: 'n',
  ne: 'ne',
  w: 'w',
  center: 'center',
  centre: 'center',
  c: 'center',
  e: 'e',
  sw: 'sw',
  s: 's',
  se: 'se',
  좌측상단: 'nw',
  중앙상단: 'n',
  우측상단: 'ne',
  좌측중앙: 'w',
  정중앙: 'center',
  중앙: 'center',
  우측중앙: 'e',
  좌측하단: 'sw',
  중앙하단: 's',
  우측하단: 'se',
};

const normalizeFieldId = (value: string): LayoutField | null => {
  const key = String(value || '').trim().toLowerCase();
  return FIELD_ALIASES[key] ?? null;
};

const normalizeAnchor = (value?: string): LayoutAnchor => {
  const key = String(value || 'n').trim().toLowerCase();
  return ANCHOR_ALIASES[key] ?? 'n';
};

const getAnchorStyle = (
  anchor: LayoutAnchor
): {
  textAlign: CanvasTextAlign;
  textBaseline: CanvasTextBaseline;
} => {
  let textAlign: CanvasTextAlign = 'center';
  let textBaseline: CanvasTextBaseline = 'middle';

  if (anchor === 'nw' || anchor === 'w' || anchor === 'sw') {
    textAlign = 'left';
  } else if (anchor === 'ne' || anchor === 'e' || anchor === 'se') {
    textAlign = 'right';
  }

  if (anchor === 'nw' || anchor === 'n' || anchor === 'ne') {
    textBaseline = 'top';
  } else if (anchor === 'sw' || anchor === 's' || anchor === 'se') {
    textBaseline = 'bottom';
  }

  return { textAlign, textBaseline };
};

/**
 * 서버의 (x, y)를 텍스트 anchor의 고정 기준점으로 사용합니다.
 *
 * - w 계열: x가 텍스트 왼쪽 끝
 * - n/center/s 계열: x가 텍스트 수평 중앙
 * - e 계열: x가 텍스트 오른쪽 끝
 * - n 계열: y가 텍스트 상단
 * - w/center/e 계열: y가 텍스트 수직 중앙
 * - s 계열: y가 텍스트 하단
 */
const drawTextWithAnchor = (
  ctx: CanvasRenderingContext2D,
  text: string,
  x: number,
  y: number,
  anchorValue?: string,
  fontSize = 20
): AnchorDrawResult => {
  const anchor = normalizeAnchor(anchorValue);
  const { textAlign, textBaseline } = getAnchorStyle(anchor);

  ctx.textAlign = textAlign;
  ctx.textBaseline = textBaseline;
  ctx.fillText(text, x, y);

  const metrics = ctx.measureText(text);
  const width = metrics.width;
  const ascent =
    metrics.actualBoundingBoxAscent > 0
      ? metrics.actualBoundingBoxAscent
      : fontSize * 0.8;
  const descent =
    metrics.actualBoundingBoxDescent > 0
      ? metrics.actualBoundingBoxDescent
      : fontSize * 0.2;
  const height = ascent + descent;

  let left = x;
  if (textAlign === 'center') {
    left = x - width / 2;
  } else if (textAlign === 'right') {
    left = x - width;
  }

  let top = y;
  if (textBaseline === 'middle') {
    top = y - height / 2;
  } else if (textBaseline === 'bottom') {
    top = y - height;
  }

  return {
    anchor,
    textAlign,
    textBaseline,
    bounds: {
      left,
      top,
      right: left + width,
      bottom: top + height,
    },
  };
};

const drawDebugGuide = (
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  result: AnchorDrawResult,
  label: string
): void => {
  const { left, top, right, bottom } = result.bounds;

  ctx.save();
  ctx.strokeStyle = '#2563eb';
  ctx.lineWidth = 1;
  ctx.setLineDash([4, 3]);
  ctx.strokeRect(left, top, right - left, bottom - top);

  ctx.setLineDash([]);
  ctx.fillStyle = '#ef4444';
  ctx.beginPath();
  ctx.arc(x, y, 4, 0, Math.PI * 2);
  ctx.fill();

  ctx.font = '12px sans-serif';
  ctx.textAlign = 'left';
  ctx.textBaseline = 'bottom';
  ctx.fillStyle = '#2563eb';
  ctx.fillText(`${label} · ${result.anchor}`, left, top - 3);
  ctx.restore();
};

const parseFont = (item: LayoutText): { family: string; size: number } => {
  if (item.font_family && item.font_size) {
    return {
      family: item.font_family.replace(/^@+/, '').trim() || 'Arial',
      size: Math.max(1, Number(item.font_size) || 20),
    };
  }

  const rawFont = item.font?.trim() || 'Arial 20';
  const match = rawFont.match(/^(.*?)(?:\s+)(\d+)(?:px|pt)?$/i);

  if (!match) {
    return {
      family: rawFont.replace(/^@+/, '').trim() || 'Arial',
      size: 20,
    };
  }

  return {
    family: match[1].replace(/^@+/, '').trim() || 'Arial',
    size: Math.max(1, Number(match[2]) || 20),
  };
};

const quoteFontFamily = (family: string): string => {
  const escaped = family.replace(/["\\]/g, '');
  return `"${escaped}"`;
};

const parseLayoutConfig = (raw: unknown): LayoutConfig => {
  if (!raw) return { texts: [] };

  if (typeof raw === 'string') {
    return JSON.parse(raw) as LayoutConfig;
  }

  if (typeof raw === 'object') {
    return raw as LayoutConfig;
  }

  return { texts: [] };
};

const loadImage = (src: string): Promise<HTMLImageElement> => {
  return new Promise((resolve, reject) => {
    const image = new Image();

    if (/^https?:\/\//i.test(src)) {
      image.crossOrigin = 'anonymous';
    }

    image.onload = () => resolve(image);
    image.onerror = () =>
      reject(new Error(`이미지를 불러오지 못했습니다: ${src}`));
    image.src = src;
  });
};

const drawBackgroundContain = (
  ctx: CanvasRenderingContext2D,
  image: HTMLImageElement,
  targetWidth: number,
  targetHeight: number
): void => {
  const sourceWidth = image.naturalWidth || image.width;
  const sourceHeight = image.naturalHeight || image.height;
  const scale = Math.min(
    targetWidth / sourceWidth,
    targetHeight / sourceHeight
  );

  const drawWidth = Math.max(1, Math.floor(sourceWidth * scale));
  const drawHeight = Math.max(1, Math.floor(sourceHeight * scale));
  const drawX = Math.floor((targetWidth - drawWidth) / 2);
  const drawY = Math.floor((targetHeight - drawHeight) / 2);

  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, targetWidth, targetHeight);
  ctx.drawImage(image, drawX, drawY, drawWidth, drawHeight);
};

const RecordMobilePrint = () => {
  const { bibNum } = useParams<{ compTitle?: string; bibNum?: string }>();
  const location = useLocation();
  const stateData = (location.state as LocationState | null) ?? {};

  const isLayoutDebug = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get('layoutDebug') === '1' || params.get('debug') === '1';
  }, [location.search]);

  const [userName] = useState(stateData.userName || '이름 없음');
  const [userBib] = useState(stateData.compBib || bibNum || '-');
  const [compDivLs] = useState(stateData.compDivLs || '-');
  const [compRecord] = useState(
    stateData.compRecord || '기록이 없습니다.'
  );
  const [userSex] = useState(stateData.sex || '-');
  const [compCodeState, setCompCodeState] = useState<number | null>(
    stateData.compCode ?? null
  );

  const [layoutConfig, setLayoutConfig] = useState<LayoutConfig | null>(null);
  const [loadStatus, setLoadStatus] = useState<LoadStatus>('loading');
  const [isReady, setIsReady] = useState(false);
  const [displayScale, setDisplayScale] = useState(1);
  const [layoutFetchedAt, setLayoutFetchedAt] = useState(0);

  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    console.info(`[RecordMobilePrint] renderer=${RENDERER_VERSION}`);
  }, []);

  useEffect(() => {
    if (stateData.compCode !== undefined) {
      setCompCodeState(stateData.compCode);
    }
  }, [stateData.compCode]);

  useEffect(() => {
    if (!compCodeState) {
      setLoadStatus('unavailable');
      return;
    }

    let cancelled = false;
    const requestTimestamp = Date.now();

    setLoadStatus('loading');
    setIsReady(false);

    axios
      .get<LayoutApiResponse>(`/api/get-layout/${compCodeState}`, {
        params: {
          mode: 'mobile',
          _ts: requestTimestamp,
        },
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0',
        },
      })
      .then((response) => {
        if (cancelled) return;

        const raw = response.data;
        let parsedObj: LayoutConfig;

        try {
          parsedObj = parseLayoutConfig(raw.layout_config);
        } catch (error) {
          console.error('레이아웃 JSON 파싱 오류:', error, raw.layout_config);
          setLayoutConfig(null);
          setLoadStatus('error');
          return;
        }

        console.info('[RecordMobilePrint] API response', raw);
        console.info('[RecordMobilePrint] parsed layout', parsedObj);
        console.table(
          (parsedObj.texts || []).map((item) => ({
            custom_id: item.custom_id,
            x: item.x,
            y: item.y,
            anchor_raw: item.anchor,
            anchor_normalized: normalizeAnchor(item.anchor),
            font_family: item.font_family,
            font_size: item.font_size,
          }))
        );

        if (!Array.isArray(parsedObj.texts) || parsedObj.texts.length === 0) {
          setLayoutConfig(null);
          setLoadStatus('unavailable');
          return;
        }

        setLayoutConfig({
          ...parsedObj,
          bg_image: raw.bg_image || undefined,
          texts: parsedObj.texts,
        });
        setLayoutFetchedAt(requestTimestamp);
        setLoadStatus('ready');
      })
      .catch((error) => {
        if (cancelled) return;
        console.error('레이아웃 불러오기 오류:', error);
        setLayoutConfig(null);
        setLoadStatus('error');
      });

    return () => {
      cancelled = true;
    };
  }, [compCodeState]);

  const orientation = layoutConfig?.page?.orientation ?? 'portrait';
  const canvasWidth =
    layoutConfig?.page?.base_width ??
    (orientation === 'landscape' ? 842 : 595);
  const canvasHeight =
    layoutConfig?.page?.base_height ??
    (orientation === 'landscape' ? 595 : 842);

  const backgroundUrl = useMemo(() => {
    if (!layoutConfig?.bg_image) return defaultBackground;

    const baseUrl = `/static/images/${layoutConfig.bg_image}`;
    const separator = baseUrl.includes('?') ? '&' : '?';
    return `${baseUrl}${separator}_ts=${layoutFetchedAt || Date.now()}`;
  }, [layoutConfig?.bg_image, layoutFetchedAt]);

  const mapping = useMemo<Record<LayoutField, string>>(
    () => ({
      name: userName,
      bib: userBib,
      div: compDivLs,
      time: compRecord,
      sex: userSex,
    }),
    [userName, userBib, compDivLs, compRecord, userSex]
  );

  useEffect(() => {
    const handleResize = () => {
      const availableWidth = Math.max(1, window.innerWidth - 20);
      setDisplayScale(Math.min(1, availableWidth / canvasWidth));
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, [canvasWidth]);

  const drawCertificate = useCallback(async (): Promise<boolean> => {
    if (!layoutConfig || !canvasRef.current) return false;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    if (!ctx) return false;

    canvas.width = canvasWidth;
    canvas.height = canvasHeight;
    ctx.clearRect(0, 0, canvasWidth, canvasHeight);

    try {
      await document.fonts?.ready;

      let background: HTMLImageElement;
      try {
        background = await loadImage(backgroundUrl);
      } catch (error) {
        console.warn(
          '지정 배경을 불러오지 못해 기본 배경을 사용합니다.',
          error
        );
        background = await loadImage(defaultBackground);
      }

      drawBackgroundContain(ctx, background, canvasWidth, canvasHeight);

      for (const item of layoutConfig.texts) {
        if (item.visible === false) continue;

        const fieldId = normalizeFieldId(item.custom_id);
        const text = fieldId
          ? mapping[fieldId]
          : item.text || item.custom_id || '';

        const { family, size } = parseFont(item);
        // 모바일 기록증은 일반 기록증과 동일한 레이아웃을 사용하되 텍스트만 굵게 표시합니다.
        const fontSpec = `bold ${size}px ${quoteFontFamily(family)}, sans-serif`;
        const x = Number(item.x) || 0;
        const y = Number(item.y) || 0;
        const rawAnchor = item.anchor;
        const normalizedAnchor = normalizeAnchor(rawAnchor);

        if (document.fonts?.load) {
          await document.fonts.load(fontSpec, text);
        }

        const fontAvailable = document.fonts
          ? document.fonts.check(fontSpec, text)
          : true;

        if (!fontAvailable) {
          console.warn(
            `[RecordMobilePrint] 웹에서 사용할 수 없는 폰트: ${family}`
          );
        }

        ctx.save();
        ctx.font = fontSpec;
        ctx.fillStyle = item.color || '#000000';

        const result = drawTextWithAnchor(
          ctx,
          text,
          x,
          y,
          rawAnchor,
          size
        );

        console.debug('[RecordMobilePrint] text draw', {
          renderer: RENDERER_VERSION,
          customId: item.custom_id,
          text,
          x,
          y,
          rawAnchor,
          normalizedAnchor,
          textAlign: result.textAlign,
          textBaseline: result.textBaseline,
          bounds: result.bounds,
          family,
          size,
          fontSpec,
          fontAvailable,
        });

        if (isLayoutDebug) {
          drawDebugGuide(
            ctx,
            x,
            y,
            result,
            `${item.custom_id}`
          );
        }

        ctx.restore();
      }

      setIsReady(true);
      return true;
    } catch (error) {
      console.error('모바일 기록증 Canvas 렌더링 오류:', error);
      setIsReady(false);
      return false;
    }
  }, [
    layoutConfig,
    canvasWidth,
    canvasHeight,
    backgroundUrl,
    mapping,
    isLayoutDebug,
  ]);

  useEffect(() => {
    setIsReady(false);

    if (loadStatus === 'ready') {
      void drawCertificate();
    }
  }, [loadStatus, drawCertificate]);

  const handleDownload = async () => {
    if (!canvasRef.current) return;

    const rendered = await drawCertificate();
    if (!rendered) return;

    try {
      const dataUrl = canvasRef.current.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = `${userBib}_모바일기록증.png`;
      link.click();
    } catch (error) {
      console.error('기록증 다운로드 오류:', error);
    }
  };

  if (loadStatus === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white">
        <p className="text-xl font-semibold text-gray-700">
          모바일 기록증 레이아웃을 불러오는 중입니다.
        </p>
      </div>
    );
  }

  if (loadStatus === 'unavailable') {
    return (
      <div className="flex min-h-screen items-start justify-center bg-white pt-40">
        <h1 className="text-center text-2xl font-bold text-red-600 md:text-4xl">
          이번 대회에서는 모바일 기록증을 서비스하지 않습니다.
        </h1>
      </div>
    );
  }

  if (loadStatus === 'error' || !layoutConfig) {
    return (
      <div className="flex min-h-screen items-start justify-center bg-white pt-40">
        <h1 className="text-center text-2xl font-bold text-red-600 md:text-4xl">
          모바일 기록증 정보를 불러오지 못했습니다.
        </h1>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center">
      <div
        className="mx-auto mb-8 mt-8 overflow-hidden bg-white"
        style={{
          width: canvasWidth * displayScale,
          height: canvasHeight * displayScale,
        }}
      >
        <canvas
          ref={canvasRef}
          style={{
            width: `${canvasWidth * displayScale}px`,
            height: `${canvasHeight * displayScale}px`,
            display: 'block',
            backgroundColor: '#ffffff',
          }}
        />
      </div>

      <div className="mb-4 flex gap-4">
        <Button
          variant="filled"
          color="blue"
          onClick={handleDownload}
          disabled={!isReady}
        >
          다운로드
        </Button>
      </div>
    </div>
  );
};

export default RecordMobilePrint;
